import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function ProfileCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("profileCard.title")}</h1>
      <p>{t("profileCard.intro")}</p>

      <CodeBlock title="profileImage()">{`import { profileImage } from "kira-arts";

const buffer = await profileImage(targetUser.id, {
  guildId: guild?.id,
  useRoleColor: true,
  presenceStatus: member?.presence?.status,
  customBadges: extraBadges.length ? extraBadges : undefined,
  badgesFrame: true,
});`}</CodeBlock>

      <p>
        <Trans i18nKey="profileCard.normalNote" components={[<code key="0" />]} />
      </p>

      <h2>{t("profileCard.addXpTitle")}</h2>
      <p>
        <Trans i18nKey="profileCard.addXpIntro" components={[<code key="0" />]} />
      </p>

      <CodeBlock title="with XP bar">{`const buffer = await profileImage(userId, {
  guildId,
  useRoleColor: true,
  rankData: { currentXp: 340, requiredXp: 500, level: 8 },
});`}</CodeBlock>

      <p>
        <Trans
          i18nKey="profileCard.rankNote"
          components={[<code key="0" />, <code key="1" />, <a key="2" href="/docs/kira-arts/cards/leaderboard" />]}
        />
      </p>

      <h2>{t("profileCard.colorOptionsTitle")}</h2>
      <CodeBlock title="ProfileOptions (excerpt)">{`borderColor?: ColorInput;
disableProfileTheme?: boolean;
useRoleColor?: boolean;
removeBorder?: boolean;
customBackground?: string;
guildId?: string;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="profileCard.nitroNote"
          components={[<code key="0" />, <code key="1" />, <a key="2" href="/docs/kira-arts/color-system" />]}
        />
      </p>

      <h2>{t("profileCard.presenceTitle")}</h2>
      <p>
        <Trans
          i18nKey="profileCard.presenceIntro"
          components={[<code key="0" />]}
        />
      </p>

      <CodeBlock title="PresenceStatus">{`"online" | "idle" | "dnd" | "offline" | "invisible" | "streaming" | "phone"`}</CodeBlock>

      <p>
        <Trans
          i18nKey="profileCard.presenceNote"
          components={[<code key="0" />]}
        />
      </p>

      <h2>{t("profileCard.avatarTitle")}</h2>
      <p>
        <Trans
          i18nKey="profileCard.avatarIntro"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <CodeBlock title="avatar + badges">{`const buffer = await profileImage(userId, {
  guildId,
  squareAvatar: true,
  badgesFrame: true,
});`}</CodeBlock>

      <p>
        <Trans
          i18nKey="profileCard.removeFrameNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <h2>{t("profileCard.textTitle")}</h2>
      <p>
        <Trans
          i18nKey="profileCard.textIntro"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <CodeBlock title="ProfileOptions (text)">{`customUsername?: string;
customTag?: string;
customSubtitle?: string;
usernameColor?: string;
tagColor?: string;`}</CodeBlock>
    </article>
  );
}
